import axios, { POST } from 'utils/axiosClient'
import { formatRequestData } from 'utils/jsonApiFormatters'

import {
    setUserId,
    setUserToken,
    setUserRefreshToken,
    setUserLanguage,
} from './localStorage.service'

import ENTITY from 'constants/entities'

export const loginService = async (formData, apiUrl) => {
    try {
        const { data } = await axios(
            POST,
            '/login_check',
            formData,
            false,
            apiUrl
        )
        if (data.token) {
            const { token, refresh_token, user_id, user_lang } = data
            setUserToken(token)
            setUserRefreshToken(refresh_token)
            setUserId(user_id)
            setUserLanguage(user_lang)
        }
        return data
    } catch (error) {
        throw error
    }
}

export const registerUserService = async (data, isJSONAPI = true, apiUrl) => {
    try {
        const preparedData = isJSONAPI
            ? formatRequestData(ENTITY.USER, data)
            : data
        await axios(POST, '/register', preparedData, isJSONAPI, apiUrl)
    } catch (error) {
        throw error
    }
}

export const forgotPasswordService = async (
    formData,
    isJSONAPI = true,
    apiUrl
) => {
    try {
        const preparedData = isJSONAPI
            ? formatRequestData(ENTITY.USER, formData)
            : formData
        const response = await axios(
            POST,
            '/forgot_password',
            preparedData,
            isJSONAPI,
            apiUrl
        )
        return response
    } catch (error) {
        throw error
    }
}

export const resetPasswordService = async (data, isJSONAPI = true, apiUrl) => {
    try {
        const preparedData = isJSONAPI
            ? formatRequestData(ENTITY.USER, data)
            : data
        await axios(POST, `/reset_password`, preparedData, isJSONAPI, apiUrl)
    } catch (error) {
        throw error
    }
}

export const unbanService = async (formData, apiUrl) => {
    try {
        return await axios(
            POST,
            '/send-unban-email',
            formData,
            false,
            apiUrl
        )
    } catch (error) {
        throw error
    }
}

export const unbanUserService = async (formData, apiUrl) => {
    try {
        return await axios(
            POST,
            '/unban-user',
            formData,
            false,
            apiUrl
        )
    } catch (error) {
        throw error
    }
}
